
import React, { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, XCircle, AlertCircle, Loader2 } from "lucide-react";

interface IntegrationCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  isConnected: boolean;
  isChecking: boolean;
  connectionError: string | null;
  children: ReactNode;
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({
  title,
  description,
  icon,
  isConnected,
  isChecking,
  connectionError,
  children
}) => {
  return (
    <Card className="p-6 shadow-sm border bg-card">
      <CardHeader className="px-0 pt-0">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            {icon}
            <CardTitle>{title}</CardTitle>
          </div>
          {isChecking ? (
            <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200 flex items-center gap-1">
              <Loader2 className="h-3 w-3 animate-spin" /> Checking...
            </Badge>
          ) : isConnected ? (
            <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200 flex items-center gap-1">
              <CheckCircle2 className="h-3 w-3" /> Connected
            </Badge>
          ) : connectionError ? (
            <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200 flex items-center gap-1">
              <XCircle className="h-3 w-3" /> Connection Error
            </Badge>
          ) : (
            <Badge variant="outline" className="bg-gray-50 text-gray-700 flex items-center gap-1">
              <AlertCircle className="h-3 w-3" /> Not Connected
            </Badge>
          )}
        </div>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="px-0 pt-2">
        {children}
      </CardContent>
    </Card>
  );
};

export default IntegrationCard;
